import {ITableSortingOption} from "@components/elements/tables/ITableSortingOption";

export class TableSortingOption implements ITableSortingOption {
    private label: string;
    private descending: boolean;
    private slug: string;

    constructor({label, descending, slug}: { label: string, descending: boolean, slug: string }) {
        this.label = label;
        this.descending = descending;
        this.slug = slug;
    }

    getDescending(): boolean {
        return this.descending;
    }

    getLabel(): string {
        return this.label;
    }

    getSlug(): string {
        return this.slug;
    }

}